import {
  CreateTenantProps,
  GetAllTenantProps,
  IsTenantAvailableProps,
} from "../../dtos/tenant";
import instance, { get, patch, post, fetchSSE } from "../../utils/BaseService";

export async function isTenantAvailable(input: IsTenantAvailableProps) {
  return await instance.get(
    `/tenant/isTenantAvailable?tenancyName=${input.tenancyName}`
  );
}

export async function isTenantNameAvailable(input: { tenantName: string }) {
  return await instance.get(
    `/tenant/isTenantNameAvailable?tenantName=${encodeURIComponent(
      input.tenantName
    )}`
  );
}

export async function getAllTenant(Data: GetAllTenantProps, dispatch: any) {
  return await get(dispatch, "/tenant/getAllTenant", Data);
}


export async function createTenant(
  data: CreateTenantProps,
  dispatch: any,
  onMessage: (msg: { status: string; message: string }) => void
) {
  return fetchSSE(dispatch, "/tenant/createTenant", data, onMessage);
}

export async function updateTenant(
  id: number,
  Data: CreateTenantProps,
  dispatch: any
) {
  return patch(dispatch, `/tenant/updateTenant/${id}`, Data);
}

export const getTenantById = async (id: string, dispatch: any) => {
  return await get(dispatch, `/tenant/getTenantById/${id}`, null);
}

export async function softDeleteTenant(id: number, dispatch: any) {
  return patch(dispatch, `/tenant/softDeleteTenant/${id}`, {});
}